import React, { Component } from 'react';

class ResultComponent extends Component {
/*  Para renderizar o conteúdo html da página   */

  render() {
    const { result } = this.props;
    return (
      <div className="result">
        <p>{result}</p>
      </div>
    );
  }
}

export default ResultComponent;
